function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="43" height="49" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#4A4A4A"><path d="M19 8h-8v8h8V8zm-1.733 6.267h-4.534V9.733h4.534v4.534zM32 8h-8v8h8V8zm-1.733 6.267h-4.534V9.733h4.534v4.534zM19 19h-8v8h8v-8zm-1.733 6.267h-4.534v-4.534h4.534v4.534zM32 19h-8v8h8v-8zm-1.733 6.267h-4.534v-4.534h4.534v4.534z" /><path d="M37.808 47.229V0H5.192v47.229H0V49h43v-1.771h-5.192zm-13.951 0h-4.713v-5.834h4.713v5.834zm12.2 0h-10.45v-7.605h-8.214v7.605H6.943V1.77h29.114v45.46z" /></g></svg>;
});